module.exports = __webpack_public_path__ + "builder-icon-keepe-1LyCNXs.svg";